import { IPoint } from "./IPoint.ts";
import { ICombatStats, TroopTrait } from "./JsonDefinitions.ts";

/**
 * Represents an army marching or returning to/from a target.
 */
export interface IMarchingArmy {
    playerId: number;
    heroId: number;
    targetLocation: IPoint;
    currentLocation: IPoint;
    targetType: TargetType;
    targetId: number;
    speed: number;

    /**
     * Timestamp when the march started.
     */
    start: number;

    /**
     * Timestamp of estimated time of arrival to destination or to home village - depending on MarchState.
     */
    eta: number;

    groups: ICombatGroup[];
    state: MarchState;
    lastMarchUpdate: number;
}

/**
 * Represents a group of same type of troops.
 */
export interface ICombatGroup {
    /**
     * Id of the troop type from 'troop-definitions.json' or ITroopDefinition.id.
     */
    troopId: number;
    count: number;

    /**
     * Effective stats of the group after applying bonuses. 
     * Used during battle calculations.
     */
    effectiveStats?: ICombatStats

    /**
     * Name of the group for turn debug/save purposes.
     */
    name?: string;

    /**
     * Trait of the group for turn debug/save purposes.
     */
    trait?: TroopTrait;
}

export enum TargetType {
    //  player is attacking an event location
    EventLocation,

    //  future feature
    InstancedLocation,

    //  No PvP for now but as Conrad would say: future feature
    Village
}

export enum MarchState {
    Marching,
    Arrived,
    Returning,
    Returned
}